import { isNil } from 'lodash'

import { TUser } from '../types'

export function isAuthenticated(user: TUser | undefined) {
  return !isNil(user?.type) && !isNil(user?.id)
}
